import { useTranslations } from '@/i18n/use-translations';
import { WaitingScreen } from '@/components/skeletons/waiting-screen';

/**
 * Hydration-fallback page rendered by React Router v7 while a route's
 * loader resolves on the first page load. Used by every route that does
 * an authenticated round-trip (`requireSession` calling `/auth/me`) so
 * the SPA paints something deterministic instead of blank-screening
 * until the network call returns.
 *
 * It is wired route-agnostically (`routes.tsx`), so it cannot know the shape of
 * the page that is arriving — which is why it gets `WaitingScreen` rather than a
 * content-shaped skeleton (IMM-743.2).
 */
export function LoadingPage() {
  const t = useTranslations('pages');

  return (
    <main className="flex min-h-screen items-center justify-center bg-canvas">
      <WaitingScreen message={t('loading')} />
    </main>
  );
}
